import type { IFieldDefinition } from '@platform/core/types';

/** Значення поля-умови рядком (вибір — значення, особа чи посилання — ідентифікатор; порожнє — ''). */
const text = (value: unknown): string => {
  if (value === null || value === undefined) return '';
  if (typeof value === 'object' && 'id' in (value as object)) return String((value as { id: unknown }).id ?? '');
  return String(value);
};

/**
 * Чи показувати поле у формі (метадані `visibleWhen`; прототип v4 baApplies бізнес-аналізу): без умови — завжди; з умовою — коли значення
 * поля-умови порожнє або входить до `in`. Приховане поле значення не втрачає. `valueOf` — поточне значення поля запису (з чернеткою).
 * Чиста функція.
 */
export function fieldVisible(field: Pick<IFieldDefinition, 'visibleWhen'>, valueOf: (key: string) => unknown): boolean {
  const condition = field.visibleWhen;
  if (!condition) return true;
  const value = text(valueOf(condition.field));
  return !value || condition.in.includes(value);
}
